import React from 'react';

import Responsive from '@/components/Responsive';
import { useBaseCardContext } from '@/modules/content/components/ContentCard/BaseCard/BaseCardContext';
import { useBaseCard } from '@/modules/content/components/ContentCard/BaseCard/Provider';
import { useAdminRoute } from '@/pages/corporate/routes/hooks/useAdminRoutes';

import { BookmarkProps } from '../types';
import BookmarkDesktop from './index.desktop';
import BookmarkMobile from './index.mobile';

const CLASSES = {
  icon: {
    notBookmarked:
      'opacity-0 xs:opacity-100 group-hover:opacity-100 group-focus-visible:opacity-100',
  },
};

const BaseCardBookmark: React.FC<BookmarkProps> = (props) => {
  const { contentId, contentType, bookmark } = useBaseCard();
  const isAdminRoute = useAdminRoute();
  const {
    bookmarks: { allowUndo },
  } = useBaseCardContext();

  if (isAdminRoute || !contentId || !contentType || bookmark === undefined) {
    return null;
  }

  return (
    <Responsive>
      <Responsive.Default>
        <BookmarkDesktop
          allowUndo={allowUndo}
          appearance="inverse"
          bookmarkId={bookmark?.id}
          className="group absolute top-12 z-20 end-8"
          classes={CLASSES}
          {...props}
          contentId={contentId}
          contentType={contentType}
        />
      </Responsive.Default>
      <Responsive.Mobile>
        <BookmarkMobile
          appearance="inverse"
          bookmarkId={bookmark?.id}
          className="absolute top-8 z-20 end-8"
          classes={CLASSES}
          {...props}
          contentId={contentId}
          contentType={contentType}
        />
      </Responsive.Mobile>
    </Responsive>
  );
};

export default BaseCardBookmark;
